import { FC } from 'react';
import { Modal as QcsModal } from '@mui/material';

import { QcsModalBox } from '../../../common/basic/QcsModalBox';
import { SectionHeader } from '../../../common/SectionHeader';
import { QcsBox } from '../../../common/basic/QcsBox';
import { QcsLoadingButton } from '../../../common/basic/QcsLoadingButton';
import { invitationGetUpdateDto, useInvitation } from './invitationFunctions';
import { InvitationRelationResponse } from '@api/models/invitation/InvitationRelationResponse';
import { invitationService } from '@api/services/services';
import { resources } from '@api/resources';

interface Props {
  workplace?: InvitationRelationResponse;
  onClose: () => void;
}

export const WorkplaceDeleteModal: FC<Props> = ({ workplace, onClose }) => {
  // fixme: create and use delete endpoint instead
  const { t, invitation, callWithLock, reloadInvitation, enqueueSuccessSnackbar } = useInvitation();

  const confirmDelete = async () => {
    await callWithLock(async () => {
      const data2 = invitationGetUpdateDto(invitation);
      const data3 = {
        ...data2,
        workplaces: data2.workplaces.filter((x) => x.id !== workplace?.workplace?.id),
      };

      await invitationService.update(invitation.id!, data3, {}, { silentSuccess: true });
      await reloadInvitation();

      enqueueSuccessSnackbar(t('invitation.workplace.workplaceDeleteSuccess'));
      onClose();
    });
  };

  return (
    <QcsModal open={!!workplace} onClose={onClose}>
      <QcsModalBox>
        <SectionHeader title={t('invitation.tabs.askDeleteWorkplace')} />
        <QcsBox sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <QcsLoadingButton resourceLoading={resources.updateInvitation} variant="contained" onClick={confirmDelete}>
            {t('common.yes')}
          </QcsLoadingButton>
          <QcsLoadingButton resourceLoading={resources.updateInvitation} variant="outlined" onClick={onClose}>
            {t('common.no')}
          </QcsLoadingButton>
        </QcsBox>
      </QcsModalBox>
    </QcsModal>
  );
};
